export function sendGuideQrCodeImage({ dispatch, sendPayload, trackingPayload, reportQrPushed }) {
  return new Promise(resolve => {
    dispatch('sendImgMessage', {
      ...sendPayload,
      onSuccess: messageId => {
        try {
          Promise.resolve(
            reportQrPushed({
              ...trackingPayload,
              messageId
            })
          ).catch(() => {})
        } finally {
          resolve(true)
        }
      },
      onError: () => resolve(false)
    })
  })
}
